import axios from 'axios';
import { api } from '../utils/helper';


//****************** GET Div ******************//
export const getCFRMDivData = async () => {
  
    //console.log("OrgID from database => ", sessionStorage.getItem('org'))
  
    try {
      let a = { projID: sessionStorage.getItem('project') , orgID: sessionStorage.getItem('org') }
      //console.log("a from getCFRMDivData rhform => ", a.projID, a.orgID)
  
      const resrep = await axios.post(
        `${api}/getcfrmdivdata`, a,
        {
          headers: {
            authorization: sessionStorage.getItem('token'),
          },
        },
      );
  
      //console.log(`getCFRMDivData controller res: `, resrep);
      return resrep;
    } catch (error) {
      //console.log(`getCFRMDivData controller error: `, error?.response?.data);
      alert(error?.response?.data?.message);
    }
  
  }

  //****************** GET Tsp ******************//
export const getCFRMTspData = async () => {
  
  //console.log("OrgID from database => ", sessionStorage.getItem('org'))

  try {
    let a = { projID: sessionStorage.getItem('project') , orgID: sessionStorage.getItem('org') }
    //console.log("a from getCFRMTspData rhform => ", a.projID, a.orgID)

    const resrep = await axios.post(
      `${api}/getcfrmtspdata`, a,
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );

    //console.log(`getCFRMTspData controller res: `, resrep);
    return resrep;
  } catch (error) {
    //console.log(`getCFRMTspData controller error: `, error?.response?.data);
    alert(error?.response?.data?.message);
  }

}

 //****************** GET Village ******************//
 export const getCFRMVillageData = async () => {
  
  //console.log("OrgID from database => ", sessionStorage.getItem('org'))

  try {
    let a = { projID: sessionStorage.getItem('project') , orgID: sessionStorage.getItem('org') }
    //console.log("a from getCFRMVillageData rhform => ", a.projID, a.orgID)

    const resrep = await axios.post(
      `${api}/getcfrmvillagedata`, a,
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );

    //console.log(`getCFRMVillageData controller res: `, resrep);
    return resrep;
  } catch (error) {
    //console.log(`getCFRMVillageData controller error: `, error?.response?.data);
    alert(error?.response?.data?.message);
  }

}

  
